import { v4 } from 'uuid';

export const localizations = (baseUrl: string, application: string): string => `${baseUrl}/${application}_en.json`;
export const localizations_new = (baseUrl: string): string => `${baseUrl}?t=${v4()}`;
